// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// tslint:disable-next-line: one-variable-per-declaration
export const environment = {
  production: true,
  environmentName: 'Produccion',
  WSIdentityUrl: 'https://certificadosapi.royal-holiday.com/WSSeguridad/',
  WSReservacionCertificados: 'https://certificadosapi.royal-holiday.com/WSReservacionCertificados/',
  // Es la URL de las imagenes, documentos y pdfs generados
  pathLocal: 'https://certificadosapi.royal-holiday.com/WSReservacionCertificados/Media/',
  //Es la URL de aplicacion PWA
  urlAppmovil: 'https://royal-getaway.com/app/',
  WsLandingPage:  'https://certificadosapi.royal-holiday.com/WSLandingPage/',
  urlLandingPage: 'https://royal-getaway.com',
  //Licencia Livechat 26/01/2021
  licenseId: '12529383',
  //webClientId: '323744024191-b926638p07o1tojrm8rpl455isijsfca.apps.googleusercontent.com'
  webClientId: '1024534500342-hifbulr8d7gs6ctk4slaluo0sfdvgbbi.apps.googleusercontent.com',
  versioninterna:'51',
  versionpublica: '1.1.51'
};
export const firebaseConfig = {
  apiKey: "AIzaSyB70gySAjIS_NlKmvqKBzY-Rad2JMQldhk",
  authDomain: "royal-travel-app-3b38e.firebaseapp.com",
  databaseURL: "https://royal-travel-app-3b38e.firebaseapp.com",
  projectId: "royal-travel-app-3b38e",
  storageBucket: "royal-travel-app-3b38e.appspot.com",
  messagingSenderId: "1024534500342",
  appId: "1:1024534500342:android:651af26f38886f24b82dd7",
  measurementId: "G-B9WGFTXBKM",
  webClientId: '1024534500342-hifbulr8d7gs6ctk4slaluo0sfdvgbbi.apps.googleusercontent.com'
};
